<template>
  <div class="SetValue-sheetEdit">
    <div class="content-row">
      <div v-if="['address', 'area'].includes(type)" class="row-left">
        <div v-if="flowVarVisible" class="var-container">
          <span class="var">{{ localValue.label }}</span>
          <div class="icon-close" @click="hideFlowVar">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <template v-else>
          <AddressSelector
            v-if="'address' == type"
            v-model="localValue.arrValue"
            :level="curControl.level"
            @input="$emit('input', localValue)"
          ></AddressSelector>
          <AddressSelector
            v-else
            v-model="localValue.arrValue"
            :level="curControl.level"
            :checkStrictly="!curControl.lastLevelOnly"
            :multiple="!curControl.oneFlag"
            @input="selectVal"
          ></AddressSelector>
        </template>
      </div>
      <div v-else-if="['date', 'time'].includes(type)" class="row-left">
        <div v-if="localValue.dateType == 'var'" class="var-container">
          <span class="var">{{ localValue.label }}</span>
          <div class="icon-close" @click="hideFlowVar">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <NormalSelect
          v-else
          class="normal-select"
          :selectList="dateTypes"
          :selectedItem.sync="localValue.dateType"
          @handle-select="selectVal('dateType')"
        ></NormalSelect>
      </div>
      <el-tooltip effect="dark" content="使用已有变量" placement="bottom-end">
        <div class="btn-add buttonSelectTrigger" @click="flowVarListVisible = true">
          <i class="el-icon-plus"></i>
        </div>
      </el-tooltip>
      <ButtonSelect
        :visible.sync="flowVarListVisible"
        :list="dataList"
        @handle-select="selectFlowVar"
        top="42"
      ></ButtonSelect>
    </div>
    <el-date-picker
      v-if="localValue.dateType == 'Custom' && !flowVarVisible"
      v-model="localValue.value"
      :type="datePickerInfo.type"
      :placeholder="datePickerInfo.placeholder"
      :default-time="datePickerInfo.defaultTime"
      :value-format="datePickerInfo.format"
      class="date-select"
      @change="selectVal"
    ></el-date-picker>
    <div
      v-if="['date', 'time'].includes(this.type) && ['Now', 'var'].includes(localValue.dateType)"
      class="date-compute"
    >
      <div class="itemTitle">运算</div>
      <div class="titleTip">
        对所选的时间 添加/减去 的时间(添加时间写正数，减去时间写负数)
      </div>
      <el-row :gutter="20">
        <el-col :span="8" class="column">
          <div class="label">年：</div>
          <el-input v-model="localValue.compute.year" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">月：</div>
          <el-input v-model="localValue.compute.month" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">日：</div>
          <el-input v-model="localValue.compute.day" size="medium" type="number"></el-input>
        </el-col>
      </el-row>
      <el-row v-if="type == 'time'" :gutter="20" class="mTop10">
        <el-col :span="8" class="column">
          <div class="label">时：</div>
          <el-input v-model="localValue.compute.hour" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">分：</div>
          <el-input v-model="localValue.compute.minute" size="medium" type="number"></el-input>
        </el-col>
        <el-col :span="8" class="column">
          <div class="label">秒：</div>
          <el-input v-model="localValue.compute.second" size="medium" type="number"></el-input>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ButtonSelect from "@/components/ButtonSelect"
import AddressSelector from "@/components/AddressSelector"
import NormalSelect from "@/components/UIComponents/NormalSelect"
import { dateTypes } from "./static"

const defaultVal = {
  isVar: false,
  label: null,
  value: null,
  arrValue: null
}
export default {
  name: "SetValue-workFlow",
  components: {
    ButtonSelect,
    AddressSelector,
    NormalSelect
  },
  props: {
    type: String,
    curControl: {
      type: Object
    },
    dataList: Array,
    value: {
      type: Object
    }
  },
  computed: {
    flowVarVisible() {
      return this.localValue.isVar
    },
    datePickerInfo() {
      if (this.type == "date") {
        return {
          type: "date",
          placeholder: "指定日期",
          defaultTime: "00:00:00",
          format: "yyyy-MM-dd"
        }
      } else if (this.type == "time") {
        return {
          type: "datetime",
          placeholder: "指定日期时间",
          defaultTime: "00:00:00",
          format: "yyyy-MM-dd HH:mm:ss"
        }
      } else return {}
    }
  },
  watch: {
    value: {
      handler() {
        this.localValue = this.value
        if (this.localValue?.value === undefined) {
          const defaultVal = this.getDefaultVal()
          for (const defaultValKey in defaultVal) {
            this.$set(this.localValue, defaultValKey, defaultVal[defaultValKey])
          }
        }
      },
      immediate: true
    }
  },
  data() {
    return {
      localValue: this.getDefaultVal(),
      flowVarListVisible: false,
      dateCompute: {},
      dateTypes,
      time: ""
    }
  },
  methods: {
    getDefaultVal() {
      switch (this.type) {
        case "address":
        case "area": {
          return {
            isVar: false,
            label: null,
            value: null,
            arrValue: null
          }
        }
        case "date":
        case "time": {
          return {
            dateType: "None",
            label: "",
            value: "",
            compute: {
              year: 0,
              month: 0,
              day: 0,
              hour: 0,
              minute: 0,
              second: 0
            }
          }
        }
      }
    },
    selectFlowVar({ item, itemParent }) {
      switch (this.type) {
        case "address":
        case "area": {
          this.localValue.label = "[" + itemParent.title + "] " + item.label
          this.localValue.value = item.value
          this.localValue.isVar = true
          this.$emit("input", this.localValue)
          break
        }
        case "date":
        case "time": {
          Object.assign(this.localValue, {
            dateType: "var",
            label: "[" + itemParent.title + "] " + item.label,
            value: item.value
          })
          this.$emit("input", this.localValue)
          break
        }
      }
    },
    hideFlowVar() {
      switch (this.type) {
        case "address":
        case "area": {
          this.localValue.isVar = false
          break
        }
        case "date":
        case "time": {
          Object.assign(this.localValue, {
            dateType: "Custom",
            label: "",
            value: ""
          })
          this.$emit("input", this.localValue)
          break
        }
      }
    },
    selectVal(from) {
      switch (this.type) {
        case "time":
        case "date": {
          if (from == "dateType") {
            Object.assign(this.localValue, { label: "", value: "" })
          }
          this.$emit("input", this.localValue)
          break
        }
        case "area": {
          let newVal = this.localValue.arrValue
          if (newVal == null || newVal.length == 0) {
            this.localValue.value = []
            this.$emit("input", this.localValue)
          } else {
            let area = []
            if (this.curControl.oneFlag) {
              area.push(newVal.join("-"))
            } else {
              newVal.forEach(item => {
                area.push(item.join("-"))
              })
            }
            this.localValue.value = area
            this.$emit("input", this.localValue)
          }
          break
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.SetValue-sheetEdit {
  .content-row {
    display: flex;
    position: relative;
    .row-left {
      flex: 1 1;
    }
    .normal-select {
      margin-top: 0;
    }
    .var-container {
      position: relative;
      padding: 3px 10px;
      background: #f8f8f8;
      border: 1px solid #ccc;
      line-height: 34px;
      border-radius: 4px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      box-sizing: border-box;
      &:hover {
        border-color: #2196f3;
      }
      .var {
        display: inline-flex;
        line-height: 28px;
        padding: 1px 10px;
        background-color: #01ca83;
        color: #fff;
        border-radius: 14px;
        border: 1px solid #9cd7f1;
      }
      .icon-close {
        position: absolute;
        top: 5px;
        right: 10px;
        width: 20px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
        cursor: pointer;
        &:hover {
          color: #1e88e5;
        }
      }
    }
    .btn-add {
      width: 40px;
      max-height: 42px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-width: 1px 1px 1px 0;
      border-style: solid;
      box-sizing: border-box;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      border-color: #ddd;
      font-size: 20px;
      color: #9e9e9e;
      cursor: pointer;
      &:hover {
        color: #1e88e5;
      }
    }
  }
  .date-compute {
    line-height: 1.4;
    .itemTitle {
      margin-top: 12px;
      margin-bottom: 8px;
    }
    .titleTip {
      font-size: 12px;
      color: #9e9e9e;
      margin-bottom: 8px;
    }
  }
  .date-select {
    margin-top: 10px;
    width: 100%;
  }
}
</style>

<style lang="scss">
.SetValue-sheetEdit {
  .content-row {
    .normal-select,
    .el-cascader {
      .el-input__inner {
        border: 1px solid #ccc;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
        &:hover {
          border-color: #2196f3;
        }
      }
    }
    .el-cascader {
      width: 100%;
    }
  }
}
</style>
